module.exports = __webpack_public_path__ + "img/bai-driver-android.e23217a8.png";